<template>
  <component :is="tag" class="item">
    <slot v-if="item" :item="item">{{ title }}</slot>
    <slot v-else name="not-found">
      <em>{{ $t("errors.notFound") }}</em>
    </slot>
  </component>
</template>

<script setup lang="ts" generic="T extends ItemType">
import { computed } from "vue";
import { useModelStore } from "@editor/items/model/model.store";
import type { ItemType } from "./ItemOfStore";

interface Props {
  type: T;
  id: number;
  tag?: string;
}
const props = withDefaults(defineProps<Props>(), {
  tag: "span"
});

const item = computed(() => {
  return useModelStore().getItem(props.type, props.id);
});
const title = computed(() => {
  if (!item.value) return "";
  if ("title" in item.value) return item.value?.title;
  return "";
});
</script>

<style></style>
